import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Providers } from './app/providers';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AppRouter } from './router';

import './app/globals.css';

const rootEl = document.getElementById('root');
if (rootEl == null) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <TooltipProvider>
          <AppRouter />
        </TooltipProvider>
      </Providers>
    </BrowserRouter>
  </React.StrictMode>,
);
